<template>
    <div>
        <b-card no-body>
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONTRATOS - Contratos Anuais</span>
                </h4>
                <filtros
                    :naturezas="naturezas"
                    :filiais="filiais"
                    :mostrarFiltroContrato="false"
                    :mostrarFiltroProcessoCliente="false"
                    tiposFiltros="anf2i"
                    @filtroAtualizado="filtro = $event"
                ></filtros>
            </b-card-body>
            <b-card-footer>
                <app-btn-voltar></app-btn-voltar>
                <b-button
                    variant="primary"
                    @click.stop="emitirRelatorio()"
                    class="ml-2"
                >
                    <span>
                        <i class="fa fa-file-o mr-2"></i> Emitir Relatório</span
                    >
                </b-button>
            </b-card-footer>
        </b-card>
    </div>
</template>

<script>
import Filtros from './Filtros'
import RelatoriosServicos from '../RelatoriosServicos'

export default {
    components: {
        Filtros
    },

    data() {
        return {
            naturezas: [
                {
                    codigo: null,
                    descricao: 'TODOS'
                },
                {
                    codigo: 0,
                    descricao: 'VENDA'
                },
                {
                    codigo: 1,
                    descricao: 'COMPRA'
                }
            ],
            filiais: [],
            filtro: {
                filial: null,
                natureza: null,
                apenasAtivos: null,
                dataInicioDe: null,
                dataInicioAte: null,
                dataFimDe: null,
                dataFimAte: null
            }
        }
    },

    methods: {
        obterFiltrosOpcoes() {
            this.$store.dispatch('addRequest')
            RelatoriosServicos.obterFiltrosOpcoes('f2').then((response) => {
                if (response) {
                    if (response.success) {
                        this.filiais = response.data.Filiais
                        this.filiais.unshift({
                            codigo: null,
                            nome: 'TODAS'
                        })
                    } else {
                        this.$toast.error(
                            'Erro ao obter opções do filtro!',
                            'ERRO',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        emitirRelatorio() {
            this.$store.dispatch('addRequest')
            RelatoriosServicos.emitirRelatorio(
                'contratosanuais',
                this.filtro
            ).then((response) => {
                if (response) {
                    if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } else {
                        this.$download(response, 'ContratosAnual.xlsx')
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    mounted() {
        this.obterFiltrosOpcoes()
    },

    watch: {
        filtro() {}
    }
}
</script>